interface IconProps {
  color?: string;
}

const HideIcon = ({ color = "#001E96" }: IconProps) => {
  return (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1.46003C8.97004 1.15183 9.98218 0.996641 11 1.00003C15.182 1.00003 18.028 3.50003 19.725 5.70403C20.575 6.81003 21 7.36103 21 9.00003C21 10.64 20.575 11.191 19.725 12.296C18.028 14.5 15.182 17 11 17C6.818 17 3.972 14.5 2.275 12.296C1.425 11.192 1 10.639 1 9.00003C1 7.36003 1.425 6.80903 2.275 5.70403C2.7935 5.02685 3.37074 4.39674 4 3.82103"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14 9.00003C14 9.79568 13.6839 10.5587 13.1213 11.1213C12.5587 11.684 11.7956 12 11 12C10.2044 12 9.44129 11.684 8.87868 11.1213C8.31607 10.5587 8 9.79568 8 9.00003C8 8.20438 8.31607 7.44132 8.87868 6.87871C9.44129 6.3161 10.2044 6.00003 11 6.00003C11.7956 6.00003 12.5587 6.3161 13.1213 6.87871C13.6839 7.44132 14 8.20438 14 9.00003Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <line
        x1="3.6234"
        y1="13.3514"
        x2="19.1234"
        y2="4.35141"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
export default HideIcon;
